export default __webpack_public_path__ + "static/media/preloader.92234b85.gif";